<!--
 * @Author: your name
 * @Date: 2021-05-25 17:06:24
 * @LastEditTime: 2021-05-25 17:20:24
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \szny-official-website\src\components\newfile\new2.vue
-->

<template>
  <div class="new1">
      

<p style="text-align:center">
    <strong><span style="font-family: Calibri;font-size: 21px"><span style="font-family:宋体">经营指标稳中有进</span></span></strong><strong><span style="font-family: 宋体;font-size: 21px">&nbsp;&nbsp;<span style="font-family:宋体">安全管理强化提升</span></span></strong>
</p>
<p style="text-align:center">
    <strong><span style="font-family: 宋体;font-size: 19px"><span style="font-family:宋体">——重庆神州召开</span><span style="font-family:Calibri">2021</span><span style="font-family:宋体">年第一季度经营分析会</span></span></strong>
</p>
<p style="text-indent:37px">
    <span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:Calibri">2021</span><span style="font-family:宋体">年</span><span style="font-family:Calibri">4</span><span style="font-family:宋体">月</span><span style="font-family:Calibri">26</span><span style="font-family:宋体">日上午，重庆公司副总经理唐新兴陪同集团谭总、张总一行对团结湖大数据产业园进行考察调研，谭总明确指出，重庆公司须密切关注团结湖项目进度，确保天然气项目开发权。</span></span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">下午</span><span style="font-family:Calibri">13:30</span><span style="font-family:宋体">，重庆公司召开了</span><span style="font-family:Calibri">2021</span><span style="font-family:宋体">年第一季度经营分析会，重庆公司全体员工参加会议，集团总裁谭佐龙和常务副总张德权出席会议，会议由重庆公司副总经理唐新兴主持。</span></span>
</p>
<p style="text-indent:37px">
    <br/>
</p>
<p style="text-align: center;">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体"><img width="432" height="324" src="../../assets/Information/zx3.png" word_img="file:///C:\Users\ADMINI~1\AppData\Local\Temp\ksohtml168\wps13.png" style="white-space: normal; background-image: url(&quot;../../assets/Information/zx3.png&quot;); background-position: center center; background-size: initial; background-repeat: no-repeat; background-attachment: initial; background-origin: initial; background-clip: initial; border: 1px solid rgb(221, 221, 221);"/></span></span>
</p>
<p>
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">会上，各部门负责人分别对本部门第一季度重点工作完成情况及第二季度工作计划进行了汇报，唐总就重庆公司第一季度经营情况向集团领导进行了汇报。</span></span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">唐总指出重庆公司第一季度除输差外各项经营指标均超计划完成，重点工作有序推进，农村市场开发效果显著，各大宗项目收款良好，燃气保险等延伸业务稳健提升。第二季度各项工作根据要求准时保质完成。</span></span>
</p>
<p style="text-indent: 37px; text-align: center;">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体"><img width="400" height="420" src="../../assets/Information/zx4.png" style="white-space: normal; background-image: url(&quot;../../assets/Information/zx4.png&quot;); background-position: center center; background-size: initial; background-repeat: no-repeat; background-attachment: initial; background-origin: initial; background-clip: initial; border: 1px solid rgb(221, 221, 221);"/></span></span>
</p>
<p style="text-indent:37px">
    <br/>
</p>
<p>
    <span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体"><br/>张总在听取完重庆公司汇报后，对重庆公司取得的成绩表示肯定，张总指出</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">来西线天然气改造工程争取</span><span style="font-family:Calibri">6</span><span style="font-family:宋体">月份前完工，同时加强安全隐患排查</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">，</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">严防第三方破坏，多举措降低输差，通过各项标准化操作流程严格规范作业。</span></span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">谭总表示重庆公司第一季度各项指标超额完成与全体员工的辛劳付出密不可分，是大家共同努力的结果。针对后期工作，谭总从员工思想、经营管理两个方面分别提出了新的要求。</span></span>
</p>
<p style="text-align: center;">
    <img width="554" height="394" src="../../assets/Information/zx5.png"  style="background:url(../../assets/Information/zx5.png) no-repeat center center;border:1px solid #ddd"/><span style=";font-family:Calibri;font-size:19px">&nbsp;</span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">在思想方面</span></span><span style=";font-family:Calibri;font-size:19px"><span style="font-family:宋体">，谭总指出</span></span><span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">全员需进一步领会董事长在年会上提出的</span><span style="font-family:宋体">“创新挖潜，安全增效”精神，直面问题并利用创新思维解决问题；既要挖掘市场潜力，也要挖掘人的潜力；切实保证公司运营安全，持续创造优质效益。</span></span>
</p>
<p style="text-indent:37px">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">经营方面，在做好农村市场开发及大宗用户开发的同时，挖掘区域工业市场，为重庆公司未来转型发展奠定基础。有效推进来西线重点工程建设，争取早日完工。有效控制输差，分析找准原因，积极进行安全隐患处理。通过科学方法和建立大宗用户气量台账，及时掌握大宗用户生产和设备检修情况，提高月用气量预测准确率。积极推行集团标准化操作流程和集团工程管理文件精神。</span></span>
</p>
<p style="text-indent: 37px; text-align: center;">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体"><img width="519" height="389" src="../../assets/Information/zx6.png" style="white-space: normal; background-image: url(&quot;../../assets/Information/zx6.png&quot;); background-position: center center; background-size: initial; background-repeat: no-repeat; background-attachment: initial; background-origin: initial; background-clip: initial; border: 1px solid rgb(221, 221, 221);"/></span></span>
</p>
<p style="text-indent:37px">
    <br/>
</p><span style="font-family: 宋体; font-size: 19px;"><br/>谭总和张总提出的工作要求指明了第二季度的工作方向，重庆公司全体员工根据集团领导的工作部署，紧紧围绕年度经营指标，保证完成年度经营任务。</span>
<p>
    <br/><br/>
</p>
<p style="margin-right:75px;text-indent:37px;text-align:center">
    <span style=";font-family:黑体;font-size:16px"><span style="font-family:黑体">2021年第一季度经营分析会全员合影</span></span>
</p>
<p style="margin-right:75px;text-indent:37px;text-align:center">
    <span style=";font-family:黑体;font-size:14px">&nbsp;</span>
</p>
<p style="text-indent:37px;text-align:right">
    <span style=";font-family:宋体;font-size:19px"><span style="font-family:宋体">文</span><span style="font-family:Calibri">/</span><span style="font-family:宋体">图 &nbsp;&nbsp;何徐梅</span></span>
</p>
<p>
    <br/>
</p>



  </div>

</template>
<script>

  import router from '@/router'

  export default {
    components: {

    },
    data() {
      return {
        htmls:''

      }
    },
    created(){

    },
    methods:{


    }
  }
</script>
<style lang="sass">

</style>



